import React from 'react'
import { Table } from 'antd'
import { observer } from 'mobx-react-lite'
import { ReportsStore } from 'store/reports.store'
import { columns } from './batches-arrival-columns'

export const BatchesArrivalReportFeature = observer(() => (
  <Table columns={columns} dataSource={ReportsStore.batchesTotalArrival} />
))
